import { useState } from "react";
import { Button } from "../design-system/Button";
import { overviewToText, copyToClipboard, type CopyableOverview } from "../lib/copy-data";

/**
 * Botón "Copiar" reutilizable: copia los datos de la sección (métricas + tabla) al portapapeles como
 * texto, listo para pegar en WhatsApp, correo o Excel. Muestra confirmación breve "¡Copiado!".
 */
export function CopyDataButton({ data, size = "sm" }: { data: CopyableOverview; size?: "sm" | "md" }): JSX.Element {
  const [copied, setCopied] = useState(false);
  const empty = data.rows.length === 0 && (!data.metrics || data.metrics.length === 0);

  const onCopy = async (): Promise<void> => {
    const ok = await copyToClipboard(overviewToText(data));
    if (ok) { setCopied(true); setTimeout(() => setCopied(false), 1800); }
  };

  return (
    <Button variant="secondary" size={size} icon={copied ? "check" : "copy"} disabled={empty} onClick={onCopy}>
      {copied ? "¡Copiado!" : "Copiar"}
    </Button>
  );
}
